import React from 'react';
import { Input } from './styles';

interface Props {
  value: string;
  onChangeText: (text: string) => void;
}

const FormSelect: React.FC<Props> = ({ onChangeText, value, children }) => {
  return <Input
    value={value}
    onChange={(e) => {
      onChangeText(e.currentTarget.value)
    }}
  >{children}</Input>;
}

export default FormSelect;